/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import SVSideShapeBatch from "App/render/webgl/renderables/batches/sv_side_shape_batch";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import WebGLContext from "App/web_gl_context";
import IScene from "js_interface/src/scene_interface";

export default
class SVCapShapeBatch extends SVSideShapeBatch {

    public static TypeName: string = "SVCapShapeBatch";

    constructor(aSceneAPI, aRenderGraph, aShapeBatchNode) {
        super(aSceneAPI, aRenderGraph, aShapeBatchNode);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aShapeBatchNode: ShapeBatchNode): SVCapShapeBatch {
        return new SVCapShapeBatch(aSceneAPI, aRenderGraph, aShapeBatchNode);
    }

    public render(aRenderPass) {
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

        // vertex ID
        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexIDForSVBuf.getWebglBuffer());
        gl.vertexAttribPointer(shader.attributeLocations.aVertexID, 1, gl.FLOAT, false, 0, 0);

        // we always have only one shape in the shapes in the shapeBatchNode
        let shapeProps = this.shapeBatchNode.placements.getObjectsArray()[0].geometry.properties;

        let i;
        let attribLocation;
        let count;

        gl.bindBuffer(gl.ARRAY_BUFFER, this._attributes.getWebglBuffer());

        if (shader.attributeLocations.a_visibility !== undefined) {
            gl.vertexAttribPointer(shader.attributeLocations.a_visibility, 1, gl.FLOAT, false, 0, this._attributes.members[1].offset);
        }

        if (shader.attributeLocations.a_manipulation !== undefined) {
            gl.vertexAttribPointer(shader.attributeLocations.a_manipulation, 1, gl.FLOAT, false, 0, this._attributes.members[2].offset);
        }

        let vertexAttribDivisorMethodRef;
        let drawArraysInstancedMethdRef;
        if (WebGLContext.isWebGL2) {
            // @ts-ignore
            vertexAttribDivisorMethodRef = gl.vertexAttribDivisor.bind(gl);
            // @ts-ignore
            drawArraysInstancedMethdRef = gl.drawArraysInstanced.bind(gl);
        } else {
            let ctx = WebGLContext.getFeatureAsExtension("INSTANCING");
            vertexAttribDivisorMethodRef = ctx.vertexAttribDivisorANGLE.bind(ctx);
            drawArraysInstancedMethdRef = ctx.drawArraysInstancedANGLE.bind(ctx);
        }

        for (i = 0; i < shapeProps.capAttribCount; i++) {
            attribLocation = shader.attributeLocations["aVertexAttrib" + i];
            gl.vertexAttribPointer(attribLocation, 4, gl.FLOAT, false, shapeProps.svStrides[i], this._attributes.members[0].offset + shapeProps.svOffsets[i]);
            vertexAttribDivisorMethodRef(attribLocation, 1);
        }

        count = shapeProps.vertexCount / shapeProps.capAttribCount;

        for (i = 0; i < 2; i++) {
            gl.uniform1i(shader.uniformLocations.u_far, i);
            drawArraysInstancedMethdRef(gl.TRIANGLES, 0, 3, count);
        }

        for (i = 0; i < shapeProps.capAttribCount; i++) {
            attribLocation = shader.attributeLocations["aVertexAttrib" + i];
            vertexAttribDivisorMethodRef(attribLocation, 0);
        }
    }
}
